/* RESPONSIBLE TEAM: team-fin-nux */

import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { schedule } from '@ember/runloop';
import { ReactRoute } from 'embercom/lib/react-route';
import type AppService from 'embercom/services/app-service';

class FinStudioRoute extends Route {
  @service declare appService: AppService;

  private get isFullPageMessengerEnabled(): boolean {
    return this.appService.app.canUseFinSuccessAgentExperimentFinStudio;
  }

  reactEnabled() {
    return !this.isFullPageMessengerEnabled;
  }

  activate() {
    if (this.isFullPageMessengerEnabled) {
      schedule('afterRender', () => {
        window.Intercom?.('startFullPageMessenger', '#fin-studio-messenger-container');
      });
    }
  }

  deactivate() {
    if (this.isFullPageMessengerEnabled) {
      window.Intercom?.('stopFullPageMessenger');
    }
  }
}

export default ReactRoute(FinStudioRoute);
